import { fetchApi, getFetchApiJSONResponse, catchFetchApiError } from 'shared/functions';

export const newsCentreUserDataService = userId => {
  return fetchApi(`/scopeuserqualification/api/get-news-centre-user-data/${userId}/`)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};
